const environment = process.env.NEXT_PUBLIC_ENVIRONMENT || 'development';
export const isDev = environment === 'development';
